import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { IconController } from "../Scripts/ImgController";
import assets from "../../assets/assets";
import axios from "axios";
import { distributionUrl } from "../Config/url";
import { useAxiosConfigGlobal } from "../Config/axios";
import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useCookies } from "react-cookie";

const Wrapper = styled.div`
  background: linear-gradient(111.08deg, #111827 0%, #0061ff 100%);
  height: 100vh;
  width: 100vw;
  position: relative;
`;

const Modal = styled.div`
  background: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1000;
`;

const Landing = ({ oneRingRulesAll }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [authenticated, setAuthenticated] = useState(false);
  const [cookie, setCookie, removeCookie] = useCookies();
  const [searchParams] = useSearchParams();
  const [showModal, setShowModal] = useState(false);
  const axiosConfig = useAxiosConfigGlobal();
  const [latestState, setLatestState] = useState("");

  const accessToken = searchParams.get("access_token");
  const authType = searchParams.get("authorized");

  const axiosHeader = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken ?? cookie.mmusic_token}`,
    },
  };

  const addHours = (date, hours) => {
    date.setTime(date.getTime() + hours * 3600000);
    return date;
  };

  useEffect(() => {
    const fetchCurrent = async () => {
      try {
        const currentRes = await axios.get(
          `${distributionUrl}panel-api/oauth/current`,
          accessToken ? axiosHeader : axiosConfig
        );
        const currentData = currentRes.data.data;

        localStorage.setItem("Current-Publisher", JSON.stringify(currentData));

        setShowModal((cookie.who_am_i !== 'manager' && currentData?.is_updatable) || false);

        setTimeout(() => setAuthenticated(true), 1000);
      } catch (err) {
        if (err.response?.status === 401) {
          oneRingRulesAll("logout");
        }
      }
    };

    if (accessToken && authType) {
      localStorage.clear();
      removeCookie("mmusic_token");
      removeCookie("who_am_i");

      setCookie("mmusic_token", accessToken, {
        expires: addHours(new Date(), authType === "publisher" ? 24 : 1),
      });

      setCookie("who_am_i", authType, {
        expires: addHours(new Date(), authType === "publisher" ? 24 : 1),
      });
      fetchCurrent();
    } else if (cookie.mmusic_token) {
      fetchCurrent();
    } else {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    const newState = location.pathname.startsWith("/music")
      ? "music"
      : "karaoke";

    const fetchContents = async () => {
      try {
        if (newState === "music") {
          const musicRes = await axios.get(
            `${distributionUrl}panel-api/oauth/contents`,
            axiosHeader
          );
          const musicData = musicRes.data.data;

          localStorage.setItem(
            "Current-Song-Ids",
            musicData["Current-Song-Ids"]
          );
          localStorage.setItem(
            "Current-Artist-Ids",
            musicData["Current-Artist-Ids"]
          );
          localStorage.setItem(
            "Current-Album-Ids",
            musicData["Current-Album-Ids"]
          );
          localStorage.setItem(
            "Current-Single-Ids",
            musicData["Current-Single-Ids"]
          );
        } else {
          const karaokeRes = await axios.get(
            `${distributionUrl}panel-api/oauth/karaoke/contents`,
            axiosHeader
          );
          const karaokeData = karaokeRes.data.data;

          localStorage.setItem(
            "Karaoke-Song-Ids",
            karaokeData["Karaoke-Song-Ids"]
          );
          localStorage.setItem(
            "Karaoke-Artist-Ids",
            karaokeData["Karaoke-Artist-Ids"]
          );
          localStorage.setItem(
            "Karaoke-Artist-Songs",
            karaokeData["Karaoke-Artist-Songs"]
          );
        }
      } catch (err) {
        if (err.response?.status === 401) {
          oneRingRulesAll("logout");
        }
      }
    };

    if (latestState !== newState) {
      fetchContents();
      setLatestState(newState);
    }
  }, [location.pathname]);

  // ✅ Scroll блоклох
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;

    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = originalOverflow;
    }

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [showModal]);

  return authenticated ? (
    <>
      {showModal && (
        <Modal>
          <div className="flex justify-center items-center pt-10 px-4 z-50">
            <div className="md:h-12 flex flex-col md:flex-row items-stretch md:items-center rounded-lg shadow-md max-w-screen-lg overflow-hidden">
              <div className="h-full hidden md:flex items-center bg-blue-600 text-white px-3 py-2">
                <IconController
                  className="h-11 w-11"
                  src={assets.svg.warning}
                />
              </div>
              <div className="h-full flex-1 flex justify-center items-center px-4 py-3 md:py-0 text-center md:text-left text-gray-900 text-sm bg-white">
                Та гэрээгээ шинэчилсний дараа орлогын мэдээлэлтэй танилцах
                боломжтой
              </div>
              <button
                className="h-full flex items-center justify-center bg-blue-600 text-white px-4 py-3 md:py-2 md:rounded-r-lg text-sm font-medium gap-1"
                onClick={() => {
                  navigate("/update-agreement");
                  setShowModal(false);
                }}
              >
                Гэрээ шинэчлэх
                <IconController
                  src={assets.svg.arrowRightWhite}
                  className="w-4 h-4"
                />
              </button>
            </div>
          </div>
        </Modal>
      )}
      <Outlet />
    </>
  ) : (
    <Wrapper>
      <div
        className="flex flex-row items-center justify-center h-full w-full animate-ping"
        style={{ animationDuration: "3s" }}
      >
        <div className="animate-pulse" style={{ animationDuration: "4s" }}>
          <IconController
            src={assets.svg.mmusicLogoWhiteSmall}
            className="w-16 h-16"
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default Landing;
